const createReactComponent = (
    editor,
    { type, name, label, category, traits, media, renderComponent, model }
) => {
    editor.DomComponents.addType(type, {
        model: {
            defaults: {
                name,
                traits,
                ...(model?.defaults || {}),
                attributes: { subtype: 'reactComponent' },
            },
            init() {
                this.listenTo(
                    this.get('traits'),
                    'change',
                    this.handleTraitChange
                );
            },
            handleTraitChange() {
                const view = this.getView();
                if (view) {
                    view.render();
                }
            },
        },
        view: {
            init() {
                this.listenTo(this.model, 'change:attributes', this.render);
                this.listenTo(this.model.get('traits'), 'change', this.render);
                this.render();
            },
            onRender({ el, model }) {
                this.updateReactComponent();
            },
            render() {
                this.updateReactComponent();
                return this;
            },
            updateReactComponent() {
                const attributes = this.model.get('attributes');
                ReactDOM.render(renderComponent(attributes), this.el);
            },
            onRemove() {
                if (this.el) {
                    ReactDOM.unmountComponentAtNode(this.el);
                }
            },
        },
    });

    editor.BlockManager.add(`${type}-block`, {
        label,
        content: {
            type,
        },
        category,
        media: media,
    });
};
export default createReactComponent;
